import React from "react";
import { Button, Stack, SxProps, Tooltip, Typography } from "@mui/material";
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import moment from "moment";
import { cohortPeriodsAtom } from "../../stores/jotai/cohortPeriods";
import { useAtom, useAtomValue } from "jotai";
import { scoringSelectedPeriodAtom } from "../../stores/jotai/scoring/selectedPeriodIndex";
import { useTheme,Theme } from '@mui/material/styles';

const WEEK_NAV_BUTTON_STYLES: SxProps = {
    borderRadius: 0,
    minWidth: "auto",
    width: "28px",
    height: "28px",
    padding: 0,
};

function ScoringWeekNav() {
    const periods = useAtomValue(cohortPeriodsAtom);
    const [selectedPeriodIndex, setSelectedPeriodIndex] = useAtom(
        scoringSelectedPeriodAtom
    );
    const isFirstWeekSelected = selectedPeriodIndex === 0;
    const isLastWeekSelected = selectedPeriodIndex === periods?.length - 1;
    const theme = useTheme();
    const onWeekButtonClick = (periodIndex) => {
        setSelectedPeriodIndex(periodIndex);
    };

    const onPreviousButtonClick = () => {
        if (!isFirstWeekSelected) {
            setSelectedPeriodIndex(selectedPeriodIndex - 1);
        }
    };

    const onNextButtonClick = () => {
        if (!isLastWeekSelected) {
            setSelectedPeriodIndex(selectedPeriodIndex + 1);
        }
    };

    const renderWeekNavTooltipTitle = (periodIndex) => {
        const period = periods[periodIndex];
        const prevPeriod = periodIndex !== 0 ? periods[periodIndex - 1] : null;
        const dateFormat = "MMM DD YYYY";
        const endDate = moment(period.endDate).format(dateFormat);
        const prevEndDate = prevPeriod
            ? moment(prevPeriod.endDate).format(dateFormat)
            : "Beginning";

        return `${prevEndDate} - ${endDate}`;
    };

    return (
        <Stack
            direction="row"
            sx={{
                alignItems: "center",
            }}
            spacing={1}
        >
            <Typography>Week: </Typography>
            <Stack
                direction="row"
                sx={{
                    alignItems: "center",
                }}
            >
                <Button
                    variant="outlined"
                    sx={{
                        ...WEEK_NAV_BUTTON_STYLES,
                        borderTopLeftRadius: "100px",
                        borderBottomLeftRadius: "100px",
                    }}
                    disabled={isFirstWeekSelected}
                    onClick={onPreviousButtonClick}
                >
                    <ChevronLeftOutlinedIcon />
                </Button>
                {periods.map((period, index) => (
                    <Tooltip
                        key={period.groupPeriodID}
                        title={renderWeekNavTooltipTitle(index)}
                    >
                        <Button
                            variant="outlined"
                            sx={{
                                ...WEEK_NAV_BUTTON_STYLES,
                                marginLeft: "-1px",
                                ...(index === selectedPeriodIndex && {
                                    backgroundColor: theme?.custom?.mainButtonHighlight,
                                    color: theme?.custom?.white,
                                    ":hover": {
                                        backgroundColor: theme?.custom?.mainButtonHighlight,
                                        color: theme?.custom?.white,
                                    },
                                }),
                            }}
                            onClick={() => {
                                onWeekButtonClick(index);
                            }}
                        >
                            {index + 1}
                        </Button>
                    </Tooltip>
                ))}
                <Button
                    variant="outlined"
                    sx={{
                        ...WEEK_NAV_BUTTON_STYLES,
                        borderTopRightRadius: "100px",
                        borderBottomRightRadius: "100px",
                        marginLeft: "-1px",
                    }}
                    disabled={isLastWeekSelected}
                    onClick={onNextButtonClick}
                >
                    <ChevronRightOutlinedIcon />
                </Button>
            </Stack>
        </Stack>
    );
}

export default ScoringWeekNav;
